import React, { useState } from 'react';

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

import { externalRoutes } from '../../../../../routes/Utils/Routes/external.routes';

export const HIDECOOKIESBANNERCOOKIE = 'hideCookiesBanner';

export const CookiesBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(
    !localStorage.getItem(HIDECOOKIESBANNERCOOKIE)
  );

  const closeBanner = () => {
    localStorage.setItem(HIDECOOKIESBANNERCOOKIE, 'true');

    setShowBanner(false);
  };

  return (
    <Collapse in={showBanner} timeout={250}>
      <div className="header-banner">
        <div className="header-banner-wrap">
          <div className="content">
            This website uses cookies to enhance its performance. By using the website, you agree to
            our &nbsp;
            <a href={externalRoutes.cookiePolicy}>Cookie Policy</a>.
          </div>
          <IconButton className="banner-close override" onClick={closeBanner}>
            <CloseRoundedIcon classes={{ root: 'icon' }} />
          </IconButton>
        </div>
      </div>
    </Collapse>
  );
};
